import { AlertSchema } from '@src/entities/Alert/includes/schemas';
import { PageableSchema, SortSchema } from '@src/shared/includes/schemas';
import { z } from 'zod';

export const ListAlertsSchema = z.object({
  content: z.array(AlertSchema),
  empty: z.boolean(),
  first: z.boolean(),
  last: z.boolean(),
  number: z.number(),
  numberOfElements: z.number(),
  pageable: PageableSchema,
  size: z.number(),
  sort: SortSchema,
  totalElements: z.number(),
  totalPages: z.number(),
});

export const ListAlertsFiltersSchema = z.object({
  alertStatuses: z.array(z.string()).optional(),
  assignedUser: z.string().optional(),
});
